import 'isomorphic-fetch'

import { sphereFlagBulkEndpoint } from '~apiConfig'
import { getApiResponseInJSON, getIdToken } from '~utils'
import {
  FETCH_SPHERE_FLAGS,
  UPDATE_SPHERE_FLAGS,
  FILTER_EVENTS_BY_FLAG
} from '../actionTypes'

export const fetchSphereFlagsList = params => async dispatch => {
  const { method, url } = sphereFlagBulkEndpoint.list
  const idToken = getIdToken()
  const apiResponse = await fetch(url, {
    body: JSON.stringify(params),
    headers: {
      Authorization: `Bearer ${idToken}`
    },
    method
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => console.error(error))

  dispatch({
    type: FETCH_SPHERE_FLAGS,
    payload: {
      ...apiResponse
    }
  })
}

export const updateSphereEventFlags = (flagObject, accessToken) => async dispatch => {
  try {
    const { method, url } = sphereFlagBulkEndpoint.update
    const idToken = getIdToken()
    await fetch(url, {
      body: JSON.stringify(flagObject),
      headers: {
        Authorization: `Bearer ${idToken}`,
        AccessToken: accessToken
      },
      method
    })
      .then(async response => await getApiResponseInJSON(response))
      .then(response => {
        const { eventsFlagMap, message, success } = response

        dispatch({
          type: UPDATE_SPHERE_FLAGS,
          payload: { eventsFlagMap, message, success }
        })
      })
      .catch((error) => {
        console.log(error)
      })
  } catch (error) {
    console.log(error)
  }
}

export const filterEventsByFlag = params => async dispatch => {
  const { method, url } = sphereFlagBulkEndpoint.filter
  const idToken = getIdToken()
  const apiResponse = await fetch(url, {
    body: JSON.stringify(params),
    headers: {
      Authorization: `Bearer ${idToken}`
    },
    method
  })
    .then(async response => await getApiResponseInJSON(response))
    .catch(error => console.error(error))
  dispatch({
    type: FILTER_EVENTS_BY_FLAG,
    payload: {
      ...apiResponse
    }
  })
}
